import ChangeColorCommand from './changeColorCommand';
import { IShader } from '../shaders/shader';
import Element from '../element';
import store from '@/store';
import { BaseTexture, Material, PBRMetallicRoughnessMaterial } from '@babylonjs/core';
import { MaterialData } from '../shaders/materialData';

export enum BedElementType {
    BODY,
    WALL,
}

export class ChangeBedColorCommand extends ChangeColorCommand {

    private name!: string;

    constructor(
        scenePreview: any,
        elements: Element[],
        shader: IShader,
        private type: BedElementType,
        onStart: () => void = () => store.commit('incrementTasks'),
        onFinish: () => void = () => store.commit('decrementTasks'),
    ) {
        super(
            scenePreview,
            elements,
            shader,
            onStart,
            onFinish,
        );
        this.assignName();
        this.savePreviousPartialColors();
    }

    public execute() {
        if (this.type === BedElementType.BODY) {
            this.changeBodyColor();
        } else {
            this.changeWallColor();
        }
        store.commit(this.mutation, this.shader);
        this.applyMaterial(this.name);
    }

    public revert() {
        this.revertCommands();
        this.previousMaterialData.forEach((data, element) => {
            this.applyMaterialData(element, data, this.name);
            element.shaderName = this.previousShader.key;
        });
        store.commit(this.mutation, this.previousShader);
    }

    protected savePreviousColors() { }

    protected savePreviousPartialColors() {
        this.elements.forEach((element) => {
            const mesh = element.meshes.find((mesh) => mesh.name.includes(this.name))!;
            const material: Material = mesh.material!;
            if (!(material instanceof PBRMetallicRoughnessMaterial)) { return; }
            const textures = this.getTextures(material);
            const data = new MaterialData(
                material.metallic,
                material.roughness,
                textures[0],
                textures[1],
            );
            this.previousMaterialData.set(element, data);
        });
    }

    private assignName() {
        if (this.type === BedElementType.BODY) {
            this.name = 'skrzynia';
        } else {
            this.name = 'zaglowek';
        }
    }

    private changeBodyColor() {
        this.previousShader = store.getters.shaders.selectedBody;
        this.mutation = 'selectBody';
    }

    private changeWallColor() {
        this.previousShader = store.getters.shaders.selectedWall;
        this.mutation = 'selectWall';
    }
}
